var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.checkingSession)?_c('div',{staticClass:"session-loading"},[_vm._v("正在加载...")]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }